import PrivateDiskIcon from './PrivateDisk';
import Search from './Search';
import PublickDisk from './PublickDisk';
import RecentlyIcon from './Recently';
import HomePageIcon from './HomePage';
import SharePageIcon from './SharePage';
import Share from './Share';
import RecycleBin from './RecycleBin';
import DiskUpload from './Upload';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import Folder from './Folder';
import Info from './Info';
import AddFolder from './AddFolder';
import CloseCircle from './CloseCircle';
import { BoldUpload as BoldUploadIcon, BoldDownload as BoldDownloadIcon, Upload as DoUploadIcon } from './UpDownload';
import UpTriangle from './UpTriangle';
import LeftTriangle from './LeftTriangle';
import DownTriangle from './DownTriangle';
import CreateIcon from './Create';
import BackArrowIcon from './BackArrow';
import BackIcon from './Back';
import SavedIcon from './Saved';
import HistoryIcon from './History';
import ExportIcon from './Export';
import MoveToIcon from './Moveto';
import DiskMoveFolder from './DiskMoveFolder';
import RenameFile from './RenameFile';
import ExternalLink from './ExternalLink';
import ExternalAccount from './ExternalAccount';
import ExternalVisit from './ExternalVisit';
import ExternalDownload from './ExternalDownload';
import RecoverIcon from './Recover';
import AddFileIcon from './AddFile';
export default {
    LeftTriangle,
    DiskUpload,
    PrivateDiskIcon,
    AddFileIcon,
    AddFolder,
    ArrowLeft,
    ArrowRight,
    Folder,
    RecycleBin,
    Info,
    Search,
    PublickDisk,
    RecentlyIcon,
    Share,
    CloseCircle,
    DoUploadIcon,
    BoldUploadIcon,
    BoldDownloadIcon,
    DownTriangle,
    UpTriangle,
    CreateIcon,
    BackArrowIcon,
    BackIcon,
    SavedIcon,
    HistoryIcon,
    ExportIcon,
    MoveToIcon,
    HomePageIcon,
    SharePageIcon,
    DiskMoveFolder,
    RenameFile,
    ExternalLink,
    ExternalAccount,
    ExternalVisit,
    ExternalDownload,
    RecoverIcon,
};
